import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'

async function resetAll(payload: any): Promise<void> {
  await stationDataConfigApi.resetAll(payload)
}

function useStationReset() {
  const queryClient = useQueryClient()

  return useMutation((payload: any) => resetAll(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.errorCode && queryKeys.stations])
      NotifyService.success('Reset All Station Success')
    },
    onError: (error: any) => {
      NotifyService.error(error)
    },
  })
}

export default useStationReset
